var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:_vm.cssClasses},[_c('a',{attrs:{"href":"javascript: void(0)"},on:{"click":_vm.onClicked}},[(_vm.icon)?_c('icon',{attrs:{"name":_vm.icon,"iconset":_vm.iconset}}):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }